import React from "react";
import { Check, X } from "lucide-react";

// "I'm available" / "Not available" toggle pair; highlights the current answer.
export default function RsvpButtons({ meeting, onRsvp, compact = false }) {
  const cur = meeting.my_rsvp?.status;
  const base = `inline-flex items-center gap-1.5 font-mono-ui uppercase tracking-[0.14em] border transition-colors ${compact ? "text-[0.65rem] px-3 py-1.5" : "text-xs px-4 py-2"}`;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`meeting-rsvp-${meeting.id}`}>
      <button
        onClick={() => onRsvp(meeting.id, "available")}
        className={`${base} ${cur === "available" ? "bg-emerald-500 border-emerald-500 text-black" : "border-emerald-500/60 text-emerald-400 hover:bg-emerald-500/10"}`}
        data-testid={`meeting-rsvp-available-${meeting.id}`}
      >
        <Check size={12} /> I&apos;m available
      </button>
      <button
        onClick={() => onRsvp(meeting.id, "unavailable")}
        className={`${base} ${cur === "unavailable" ? "bg-[var(--ff-red)] border-[var(--ff-red)] text-white" : "border-[var(--ff-red)]/60 text-[var(--ff-red)] hover:bg-[var(--ff-red)]/10"}`}
        data-testid={`meeting-rsvp-unavailable-${meeting.id}`}
      >
        <X size={12} /> Not available
      </button>
    </div>
  );
}
